<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'新闻资讯'"></navBox>
			<!--导航-->
			<!--位置-->
			<div v-if="infoData" class="location_box">
				<div
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="location_box_main"
				>
					<span @click="goHome">首页</span>&ensp;/&ensp;<span @click="goBack">新闻资讯</span>&ensp;/&ensp;<span class="last">{{ infoData.title }}</span>
				</div>
			</div>
			<!--位置-->
			<div class="block_1">
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
					class="block_1_main"
				>
					<div v-if="infoData" class="tit_box">
						<div class="tit">{{ infoData.title }}</div>
						<div class="time">发布日期：{{ infoData.fabu_time }}</div>
					</div>
					<div v-if="infoData" v-html="infoData.content" class="content_box"></div>
					<div class="check_box">
						<div v-if="prevList" class="check_box_el" :style="nextList ? 'margin-right: 50px;' : ''">
							<div class="tit">上一篇：</div>
							<div class="txt" @click="goInfo(prevList)">{{ prevList.title }}</div>
						</div>
						<div v-if="nextList" class="check_box_el" :style="prevList ? 'margin-left: 50px;' : ''">
							<div class="tit">下一篇：</div>
							<div class="txt" @click="goInfo(nextList)">{{ nextList.title }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { newsInfo } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nextList: null,
			prevList: null,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		//请求详情接口
		if(that.$route.params.newInfoId) {
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			newsInfo({ id: that.$route.params.newInfoId.split('.')[0] }).then(res => {
				that.infoData = res.data.info;
				that.nextList = res.data.nextinfo;
				that.prevList = res.data.preinfo;
				document.title = that.infoData.title;
				that.$toast.clear();
			});
		}else {
			that.$toast('数据请求异常');
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goHome() {
			this.$router.push({ path: '/' });
		},
		goBack() {
			if(this.infoData.leixing == 1) {
				this.$router.push({ path: '/news/dynamics.html' });
			}else if(this.infoData.leixing == 2) {
				this.$router.push({ path: '/news/introduction.html' });
			}
		},
		//进入详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
			that.$router.replace({ path: routeData.href });
			window.location.reload();
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		background-color: #f6f6f6;
		.block_1_main{
			width: 1200px;
			margin: 0 auto;
			.check_box{
				display: flex;
				padding-bottom: 60px;
				.check_box_el{
					flex: 1;
					display: flex;
					cursor: pointer;
					.txt{
						flex: 1;
						line-height: 1.8;
						font-size: 18px;
					}
					.tit{
						width: auto;
						font-size: 18px;
					}
				}
			}
			.content_box{
				word-break: break-all;
				margin: 60px 0;
				padding: 50px 0;
				border-top: 1px solid #EEEEEE;
				border-bottom: 1px solid #EEEEEE;
			}
			.tit_box{
				padding-top: 40px;
				.time{
					padding-top: 20px;
					font-size: 18px;
					color: #999999;
					text-align: center;
				}
				.tit{
					padding: 0 200px;
					font-size: 44px;
					font-weight: bold;
					text-align: center;
				}
			}
		}
	}
	//位置
	.location_box{
		background-color: #f6f6f6;
		.location_box_main{
			width: 1200px;
			margin: 0px auto;
			padding: 40px 0;
			span{
				cursor: pointer;
			}
			span.last{
				color: #999999;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
</style>